import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationCode } from '../enums/application_code';
import { ApplicationUtils } from '../utils/application.utils';

@Pipe({
  name: 'isTypDokumentuZus',
  standalone: true,
})
export class IsTypDokumentuZusPipe implements PipeTransform {
  transform(value?: string | ApplicationCode | null) {
    return value != null
      ? ApplicationUtils.isFromZus(value as ApplicationCode)
      : false;
  }
}
